import React, { useState } from 'react';

const DisclaimerBanner = ({ variant = 'full' }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  if (variant === 'compact') {
    return (
      <div className="bg-blue-50 border-l-4 border-blue-400 py-3 px-4" data-testid="disclaimer-banner">
        <div className="max-w-7xl mx-auto">
          <button
            onClick={() => setIsExpanded(!isExpanded)}
            className="w-full text-left flex items-center justify-between"
          >
            <div className="flex items-center gap-3">
              <span className="text-blue-600 text-xl">ℹ️</span>
              <p className="text-sm font-medium text-blue-900">
                Important Safety Information
              </p>
            </div>
            <span className="text-blue-600 font-semibold text-sm">
              {isExpanded ? '▼' : '►'}
            </span>
          </button>
          
          {isExpanded && (
            <div className="mt-3 pl-9 space-y-2 text-sm text-blue-800 leading-relaxed">
              <p>
                This platform is not an emergency or crisis response service. Ment-Ally provides information to help you find mental health support, but it does not replace professional emergency care.
              </p>
              <p className="font-medium">If you're in immediate danger:</p>
              <ul className="space-y-1 ml-4">
                <li>• Call Tele-MANAS: <strong>14416</strong> or <strong>1-800-891-4416</strong> (24/7)</li>
                <li>• Emergency services: <strong>112</strong></li>
                <li>• Contact a trusted person nearby</li>
              </ul>
            </div>
          )}
        </div>
      </div>
    );
  }

  return (
    <div className="bg-gradient-to-r from-blue-50 to-teal-50 border-b border-blue-100 py-6 px-4" data-testid="disclaimer-banner-full">
      <div className="max-w-4xl mx-auto">
        <div className="flex items-start gap-4">
          <div className="flex-shrink-0 w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center">
            <span className="text-2xl">ℹ️</span>
          </div>
          <div className="flex-1 space-y-4">
            <div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">
                Important Safety Information
              </h3>
              <p className="text-base text-gray-700 leading-relaxed">
                This platform is not an emergency or crisis response service. Ment-Ally provides information to help you find mental health support, but it does not replace professional emergency care.
              </p>
            </div>

            <div className="bg-white rounded-xl p-5 border-2 border-blue-200">
              <p className="font-semibold text-gray-900 mb-3 text-base">
                If you or someone else is in immediate danger or experiencing a mental health crisis:
              </p>
              <div className="space-y-3">
                <div className="flex items-start gap-3">
                  <span className="text-teal-600 text-xl flex-shrink-0">📞</span>
                  <div>
                    <p className="font-semibold text-gray-900">
                      Call Tele-MANAS: <span className="text-teal-600">14416</span> or <span className="text-teal-600">1-800-891-4416</span>
                    </p>
                    <p className="text-sm text-gray-600">Government of India's 24/7 mental health helpline</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <span className="text-teal-600 text-xl flex-shrink-0">🚨</span>
                  <div>
                    <p className="font-semibold text-gray-900">
                      Call emergency services: <span className="text-teal-600">112</span>
                    </p>
                    <p className="text-sm text-gray-600">For immediate medical or police assistance</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <span className="text-teal-600 text-xl flex-shrink-0">🤝</span>
                  <div>
                    <p className="font-semibold text-gray-900">Contact a trusted person nearby</p>
                    <p className="text-sm text-gray-600">Family member, friend, or caregiver who can help</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DisclaimerBanner;
